{
  "bot_control_center": {
    "breadcrumb": "Empresa / Atendimento automático",
    "title": "Centro de Controle do Atendimento Automático",
    "loading": "Carregando o Centro de Controle...",
    "load_error": "Não foi possível carregar o Centro de Controle.",
    "retry": "Tentar novamente",
    "yes": "Sim",
    "no": "Não",
    "available": "Disponível",
    "unavailable": "Indisponível",
    "enabled": "Habilitado",
    "disabled": "Desabilitado",
    "assistive_ai": "IA assistiva",
    "explain": "Entender",
    "configuration": {
      "breadcrumb": "Empresa / Bot de Atendimento",
      "title": "Bot de Atendimento",
      "subtitle": "Configure o fluxo, revise cada etapa e acompanhe as decisões do atendimento automático.",
      "apply_default": "Aplicar fluxo padrão",
      "save": "Salvar configurações",
      "loading": "Carregando configurações do bot...",
      "not_configured": "Não configurado",
      "team": "Equipe da loja",
      "user_fallback": "Usuário {id}",
      "main_settings": "Configurações principais",
      "bot_active": "Bot ativo",
      "bot_inactive": "Bot inativo",
      "ok": "OK",
      "pending": "Pendente",
      "configured": "Configurada",
      "open": "Abrir",
      "close": "Fechar",
      "advanced_mode": "Modo avançado",
      "action": "Ação",
      "priority": "Prioridade",
      "keywords": "Palavras",
      "summary": {
        "answers_when": "Quando o bot responde",
        "handoff_target": "Quem assume quando precisa de humano",
        "off_hours": "O que acontece fora do horário",
        "default_flow": "Fluxo padrão",
        "ready": "Pronto para uso",
        "needs_configuration": "Ainda precisa de configuração"
      },
      "fields": {
        "enable_bot": "Ativar bot de atendimento",
        "allow_handoff": "Permitir transferência para atendente",
        "assignment_mode": "Como distribuir novos leads",
        "default_user": "Usuário padrão",
        "answer_policy": "Quando o bot pode responder",
        "off_hours_policy": "Política fora do horário",
        "session_timeout": "Tempo de sessão (min)",
        "max_retries": "Tentativas antes de transferir"
      },
      "assignment_modes": {
        "default": "Usuário padrão",
        "queue": "Fila de usuários",
        "bot_system": "Sistema bot"
      },
      "answer_policies": {
        "always": "Sempre",
        "business_hours_only": "Somente no horário comercial",
        "off_hours_only": "Somente fora do horário",
        "never": "Nunca"
      },
      "off_hours_policies": {
        "queue": "Manter na fila",
        "keep_assigned": "Manter responsável atual",
        "bot_only": "Deixar apenas com o bot"
      },
      "weekdays": { "0": "Dom", "1": "Seg", "2": "Ter", "3": "Qua", "4": "Qui", "5": "Sex", "6": "Sáb" },
      "dependencies": {
        "kicker": "Dependências",
        "title": "O que influencia o comportamento do bot",
        "business_hours": "Horários comerciais",
        "templates": "Templates",
        "integrations": "Integrações",
        "no_business_hours": "Horários não configurados",
        "more_hours": "+{count} horários",
        "template_count": "{count} template(s) disponível(is)",
        "no_templates": "Nenhum template cadastrado",
        "no_integrations": "Nenhuma integração ativa"
      },
      "alerts": {
        "bot_disabled": {
          "title": "Bot desativado",
          "description": "O bot está configurado, mas não responderá até ser ativado."
        },
        "business_hours_missing": {
          "title": "Horários comerciais não configurados",
          "description": "Configure os horários para que as regras de horário comercial funcionem corretamente."
        },
        "guided_flow_incomplete": {
          "title": "Fluxo guiado incompleto",
          "description": "O fluxo padrão ainda não foi aplicado por completo nesta empresa."
        },
        "bot_user_missing": {
          "title": "Usuário do bot não provisionado",
          "description": "O usuário virtual será criado automaticamente quando o fluxo precisar dele."
        },
        "templates_missing": {
          "title": "Sem templates cadastrados",
          "description": "Os atalhos continuam disponíveis, mas nenhum template foi encontrado para esta empresa."
        }
      },
      "flow": {
        "kicker": "Fluxo do atendimento",
        "title": "Cada etapa leva a uma ação do bot",
        "extra_rules": "{count} regra(s) extra(s)",
        "when": "Quando isso acontece",
        "action": "O que o bot faz",
        "next": "Próximo passo",
        "main_message": "Mensagem principal",
        "preview": "Prévia para o usuário",
        "no_message": "Sem mensagem configurada.",
        "retry_message": "Mensagem de nova tentativa",
        "retry_preview": "Prévia da nova tentativa",
        "trigger_keywords": "Palavras que disparam esta etapa",
        "trigger_keywords_example": "Ex.: oi, olá, bom dia",
        "handoff_keywords": "Palavras que pedem humano",
        "handoff_keywords_example": "Ex.: humano, atendente, vendedor",
        "no_technical_rule": "Nenhuma regra técnica associada a esta etapa."
      },
      "stages": {
        "welcome": {
          "title": "Entrada inicial",
          "when": "Quando o cliente inicia a conversa.",
          "action": "Recebe o cliente e inicia a triagem.",
          "next": "Captura do nome"
        },
        "capture_name": {
          "title": "Captura do nome",
          "when": "Quando o bot pede o nome e interpreta a resposta do cliente.",
          "action": "Identifica o nome, confirma o cadastro e pede nova tentativa se necessário.",
          "next": "Entendimento do interesse"
        },
        "interest_prompt": {
          "title": "Entendimento do interesse",
          "when": "Quando o nome já foi registrado e o bot precisa entender o interesse.",
          "action": "Conduz a conversa para o assunto do atendimento.",
          "next": "Pedido de humano ou continuidade do atendimento"
        },
        "handoff_request": {
          "title": "Pedido de humano",
          "when": "Quando o cliente pede atendimento humano.",
          "action": "Transfere para atendente seguindo a política da empresa.",
          "next": "Atendente humano"
        },
        "offhours_default": {
          "title": "Fora do horário",
          "when": "Quando a conversa acontece fora do horário comercial.",
          "action": "Explica a indisponibilidade e mantém o atendimento fora do horário.",
          "next": "Retorno no próximo horário útil ou continuidade restrita"
        }
      },
      "states": {
        "inicio": "Início",
        "captura_nome": "Captura de nome",
        "captura_interesse": "Captura de interesse",
        "agendar": "Agendar",
        "fora_do_horario": "Fora do horário",
        "encerrado": "Encerrado",
        "humano": "Atendimento humano"
      },
      "monitoring": {
        "kicker": "Monitoramento",
        "title": "Por que o bot fez isso?",
        "sessions": "Sessões",
        "logs": "Logs",
        "recent_sessions": "Sessões recentes",
        "recent_logs": "Logs recentes",
        "contact": "Contato",
        "lead": "Lead",
        "stage": "Etapa",
        "last_activity": "Última atividade",
        "summary": "Resumo",
        "no_lead": "Sem lead",
        "view_timeline": "Ver linha do tempo",
        "no_sessions": "Nenhuma sessão recente para esta empresa.",
        "time": "Horário",
        "inbound_message": "Mensagem recebida",
        "matched_rule": "Regra aplicada",
        "actions": "Ações",
        "final_stage": "Etapa final",
        "no_rule": "Sem regra identificada",
        "not_identified": "Não identificado",
        "no_actions": "Sem ações registradas",
        "explain_response": "Entender resposta",
        "no_logs": "Nenhum log recente para esta empresa.",
        "no_recent_log": "Sem log recente",
        "session_timeline": "Sessão do bot",
        "log_timeline": "Log do bot"
      },
      "timeline": {
        "current_state": "Etapa atual",
        "last_activity": "Última atividade",
        "last_inbound": "Última mensagem recebida",
        "customer_sent": "Cliente enviou",
        "state_before": "Bot estava na etapa",
        "rule_applied": "Regra aplicada",
        "action_executed": "Ação executada",
        "state_after": "Etapa final"
      },
      "advanced": {
        "kicker": "Avançado",
        "title": "Regras técnicas do bot",
        "rule_count": "{count} regra(s)",
        "description": "Descrição",
        "type": "Tipo",
        "guided": "Guiada",
        "extra": "Extra",
        "system_key": "Chave do sistema",
        "no_rules": "Nenhuma regra técnica cadastrada.",
        "technical_rule": "Regra técnica"
      },
      "actions": {
        "reply": "Responder",
        "set_context": "Atualizar contexto",
        "create_lead": "Criar ou atualizar lead",
        "schedule": "Agendar",
        "handoff": "Transferir para atendente",
        "ask_name": "Pedir nome novamente",
        "capture_name": "Capturar nome",
        "offhours_reply": "Responder fora do horário"
      },
      "preview": {
        "company": "Loja Exemplo",
        "customer": "Maria Cliente",
        "agent": "Carlos Vendedor",
        "message": "Olá, preciso de ajuda com um SUV."
      },
      "notifications": {
        "load_error": "Não foi possível carregar a configuração do bot.",
        "saved": "Configurações do bot salvas com sucesso.",
        "save_error": "Não foi possível salvar as configurações do bot.",
        "bootstrap_success": "Fluxo padrão aplicado com sucesso.",
        "bootstrap_error": "Não foi possível aplicar o fluxo padrão."
      }
    },
    "tabs": {
      "overview": "Visão geral",
      "config": "Configuração",
      "operations": "Conversas e decisões",
      "diagnostics": "Diagnóstico"
    },
    "engines": { "none": "Nenhum", "rules": "Fluxo por regras", "orchestrator": "Fluxo inteligente" },
    "outcomes": {
      "replied": "Respondeu",
      "skipped": "Ignorou",
      "handoff": "Transferiu para atendente",
      "error": "Erro",
      "no_reply": "Sem resposta"
    },
    "statuses": { "operating": "Operando", "paused": "Pausado", "partial": "Parcial", "error": "Com erro" },
    "llm_statuses": {
      "active": "Ativa",
      "canary": "Em piloto",
      "unavailable": "Indisponível",
      "not_enabled": "Não habilitada"
    },
    "readiness": {
      "healthy": "Normal",
      "degraded": "Degradada",
      "unavailable": "Indisponível",
      "unknown": "Desconhecida"
    },
    "status": {
      "automatic_service": "Atendimento automático",
      "answers_now": "Atende agora?",
      "in_business_hours": "Dentro do horário comercial",
      "outside_business_hours": "Fora do horário comercial",
      "main_flow": "Fluxo principal",
      "continuity_available": "Continuidade pelas regras disponível",
      "continuity_unavailable": "Sem continuidade configurada",
      "calls_today": "{calls} / {limit} chamadas hoje",
      "calculated_at": "Situação calculada em {date}",
      "last_execution": "Última execução",
      "view_conversation": "Ver conversa"
    },
    "analytics": {
      "title": "Indicadores",
      "loading": "Carregando indicadores...",
      "error": "Não foi possível carregar os indicadores.",
      "empty": "Sem dados para o período.",
      "stale": "Indicadores ainda não consolidados para este período.",
      "partial": "Alguns dias ainda estão sendo consolidados; os números podem variar.",
      "today": "Hoje",
      "days_7": "7 dias",
      "days_30": "30 dias",
      "orchestrator": "Orquestrador",
      "success": "sucesso",
      "continuity": "continuidade",
      "errors": "Erros",
      "calls": "chamadas",
      "uses": "usos",
      "latency": "Latência p50/p95",
      "inbound_evaluated": "Entradas avaliadas",
      "automated_replies": "Respostas automáticas",
      "automation_rate": "Taxa de automação",
      "handoffs": "Transferências",
      "no_reply": "Sem resposta"
    },
    "flow": {
      "title": "Tratamento da mensagem",
      "policy": "Política e horário",
      "policy_detail": "Verifica se o atendimento automático deve responder agora.",
      "smart_primary": "Fluxo inteligente (principal)",
      "rules_primary": "Fluxo por regras (principal)",
      "smart_detail": "Entende a mensagem e decide a melhor resposta.",
      "rules_detail": "Aplica as regras configuradas da loja.",
      "ai": "IA assistiva quando necessário",
      "ai_detail": "A IA só é chamada quando as regras não entendem a mensagem.",
      "tools": "Estoque e agendamento",
      "tools_detail": "Consulta estoque e agenda visitas quando solicitado.",
      "delivery": "Resposta ou atendente",
      "delivery_detail": "Envia a resposta automática ou transfere para um atendente.",
      "continuity": "Em caso de falha, o atendimento continua pelo fluxo por regras."
    },
    "diagnostics": {
      "health": "Saúde e continuidade",
      "readiness": "Disponibilidade do fluxo inteligente",
      "observed_at": "observado em {date}",
      "no_heartbeat": "sem sinal recente",
      "rules_continuity": "Continuidade por regras",
      "recent_window": "Janela recente (24h)",
      "recent_values": "{total} execuções · {errors} erros · {fallbacks} continuidades",
      "rollout_source": "Origem do rollout",
      "platform": "Governado pela plataforma",
      "legacy": "Configuração legada",
      "ai_usage": "Uso da IA assistiva",
      "state": "Estado",
      "classify": "Entendimento (classify)",
      "rewrite": "Naturalização (rewrite)",
      "daily_usage": "Consumo diário",
      "calls": "{calls} / {limit} chamadas",
      "stage": "Estágio"
    },
    "executions": {
      "title": "Conversas e decisões",
      "search": "Buscar por lead ou telefone",
      "outcome": "Resultado",
      "engine": "Motor",
      "ai_used": "IA usada",
      "with_ai": "Com IA",
      "without_ai": "Sem IA",
      "protection": "Proteção",
      "protection_applied": "Proteção aplicada",
      "protection_not_applied": "Sem proteção aplicada",
      "date_from": "Data inicial",
      "date_to": "Data final",
      "loading": "Carregando execuções...",
      "error": "Não foi possível carregar as execuções.",
      "empty": "Nenhuma execução no período ou filtros.",
      "caption": "Execuções do atendimento automático",
      "date_time": "Data/hora",
      "lead": "Lead",
      "message": "Mensagem",
      "action": "Ação",
      "latency": "Latência",
      "details": "Detalhes",
      "inventory": "Estoque",
      "schedule": "Agenda"
    },
    "drawer": {
      "title": "Entender esta resposta",
      "loading": "Carregando explicação...",
      "error": "Não foi possível carregar esta execução.",
      "empty_trace": "Esta execução não possui etapas registradas.",
      "technical": "Detalhes técnicos",
      "execution": "Execução",
      "communication": "Comunicação",
      "status": "Status",
      "attempts": "Tentativas",
      "confidence": "Confiança",
      "ai_path": "Caminho da IA",
      "ai_calls": "Chamadas de IA",
      "latency": "Latência",
      "engine_value": "motor: {value}",
      "tool_value": "ferramenta: {value}",
      "confidence_value": "confiança: {value}",
      "tools": { "inventory_search": "consulta de estoque", "schedule_visit": "agendamento de visita" },
      "confidence_bands": { "low": "baixa", "medium": "média", "high": "alta" },
      "results": "{count} resultado(s)",
      "steps": {
        "policy": "Política e horário",
        "engine": "Motor de atendimento",
        "intent": "Entendimento da mensagem",
        "tool": "Consulta de estoque",
        "schedule": "Agendamento",
        "guardrail": "Proteção de resposta",
        "handoff": "Transferência para atendente",
        "delivery": "Entrega da resposta"
      },
      "step_outcomes": {
        "allowed": "permitido",
        "blocked": "bloqueado",
        "skipped": "ignorado",
        "selected": "selecionado",
        "fallback": "continuidade acionada",
        "requested": "solicitado",
        "sent": "enviada",
        "no_reply": "sem resposta",
        "applied": "aplicada",
        "failed": "falhou"
      }
    },
    "chat": {
      "automatic": "Automática",
      "automatic_label": "Enviada pelo atendimento automático",
      "guardrail": "Proteção de resposta aplicada",
      "explain_action": "Entender atendimento automático",
      "no_auto_reply": "Sem resposta automática",
      "no_execution": "Esta mensagem não possui uma execução explicável.",
      "imported_history": "Histórico importado"
    },
    "reasons": {
      "bot_disabled": "Atendimento automático desligado pelo administrador.",
      "policy_never": "A política da loja é nunca responder automaticamente.",
      "policy_blocked": "A política atual não permite resposta automática agora.",
      "outside_business_hours": "Fora do horário comercial.",
      "inside_business_hours": "Dentro do horário comercial.",
      "new_lead_off_hours_override": "Lead novo atendido fora do horário (exceção habilitada).",
      "human_already_assigned": "Conversa já está com um atendente humano.",
      "missing_contact_key": "Contato sem telefone ou identificador para responder.",
      "orchestrator_disabled": "Fluxo inteligente desligado para esta loja.",
      "orchestrator_timeout": "Fluxo inteligente demorou a responder; seguimos pelas regras.",
      "orchestrator_unavailable": "Fluxo inteligente indisponível; seguimos pelas regras.",
      "orchestrator_contract_error": "Resposta inesperada do fluxo inteligente; seguimos pelas regras.",
      "rules_fallback": "Continuidade automática pelas regras da loja.",
      "no_rule_matched": "Nenhuma regra entendeu a mensagem.",
      "rules_replied": "Respondido pelo fluxo por regras.",
      "llm_not_needed": "A IA assistiva não foi necessária.",
      "llm_disabled": "IA assistiva desligada.",
      "llm_budget_exhausted": "IA assistiva atingiu o limite diário; seguimos pelo fluxo seguro.",
      "llm_breaker_open": "IA assistiva temporariamente indisponível; fluxo seguro mantido.",
      "llm_schema_invalid": "Resposta da IA descartada por segurança; fluxo seguro mantido.",
      "llm_low_confidence": "IA com baixa confiança; fluxo determinístico mantido.",
      "llm_success": "Entendimento assistido pela IA.",
      "llm_fallback_success": "IA assistiva respondeu pela continuidade.",
      "guardrail_rewrite": "Proteção aplicada à resposta gerada.",
      "guardrail_commercial": "Proteção comercial aplicada à resposta.",
      "inventory_ok": "Estoque consultado com opções disponíveis.",
      "inventory_empty": "Estoque consultado sem opções no momento.",
      "inventory_unavailable": "Consulta de estoque indisponível.",
      "schedule_created": "Visita agendada.",
      "schedule_already_exists": "Visita já estava agendada.",
      "schedule_failed": "Não foi possível agendar a visita.",
      "handoff_requested": "Transferência para atendente solicitada.",
      "delivery_failed": "Falha ao enviar a resposta.",
      "idempotency_hit": "Mensagem repetida ignorada (já tratada).",
      "engine_error": "Erro ao processar a mensagem."
    }
  },
  "auth": {
    "agree": "Eu aceito.",
    "createAccount": "Criar conta",
    "createNewAccount": "Criar uma nova conta",
    "email": "Email",
    "login": "Entrar",
    "password": "Senha",
    "recover_password": "Recuperar senha",
    "sign_up": "Cadastrar-se",
    "keep_logged_in": "Mantenha-me conectado",
    "termsOfUse": "Termos de uso.",
    "reset_password": "Redefinir senha"
  },
  "404": {
    "title": "Esta página está pescando.",
    "text": "Se você acha que isso não está certo, envie-nos uma mensagem em ",
    "back_button": "Voltar para o painel"
  },
  "typography": {
    "primary": "Estilos de texto primários",
    "secondary": "Estilos de texto secundários"
  },
  "dashboard": {
    "versions": "Versões",
    "setupRemoteConnections": "Configurar Conexões Remotas",
    "currentVisitors": "Visitantes Atuais",
    "charts": {
      "trendyTrends": "Tendências na moda",
      "showInMoreDetail": "Mostrar em mais detalhes",
      "showInLessDetail": "Mostrar em menos detalhes",
      "loadingSpeed": "Velocidade de carregamento",
      "topContributors": "Principais colaboradores",
      "showNextFive": "Mostrar próximos cinco",
      "commits": "Commits"
    },
    "info": {
      "componentRichTheme": "tema rico em componentes",
      "completedPullRequests": "solicitações de pull concluídas",
      "users": "usuários",
      "points": "pontos",
      "units": "unidades",
      "exploreGallery": "Explorar galeria",
      "viewLibrary": "Ver Biblioteca",
      "commits": "commits",
      "components": "componentes",
      "teamMembers": "membros da equipe"
    },
    "tabs": {
      "overview": {
        "title": "Visão Geral",
        "built": "Construído com o framework Vue.js",
        "free": "Totalmente gratuito para todos",
        "fresh": "Design fresco e nítido",
        "mobile": "Responsivo e otimizado para dispositivos móveis",
        "components": "Toneladas de componentes úteis",
        "nojQuery": "Completamente livre de jQuery"
      },
      "billingAddress": {
        "title": "Endereço de Cobrança",
        "personalInfo": "Informação Pessoal",
        "firstName": "Nome e Sobrenome",
        "email": "Email",
        "address": "Endereço",
        "companyInfo": "Informação da Empresa",
        "city": "Cidade",
        "country": "País",
        "infiniteConnections": "Conexões infinitas",
        "addConnection": "Adicionar Conexão"
      },
      "bankDetails": {
        "title": "Detalhes Bancários",
        "detailsFields": "Campos de Detalhes",
        "bankName": "Nome do Banco",
        "accountName": "Nome da Conta",
        "sortCode": "Código de Ordenação",
        "accountNumber": "Número da Conta",
        "notes": "Notas",
        "sendDetails": "Enviar Detalhes"
      }
    },
    "navigationLayout": "layout de navegação",
    "topBarButton": "Barra Superior",
    "sideBarButton": "Barra Lateral"
  },
  "language": {
    "brazilian_portuguese": "Português",
    "english": "Inglês",
    "spanish": "Espanhol"
  },
  "menu": {
    "auth": "Autenticação",
    "buttons": "Botões",
    "timelines": "Linhas do Tempo",
    "dashboard": "Painel de Controle",
    "billing": "Cobrança",
    "login": "Entrar",
    "signUp": "Cadastrar-se",
    "preferences": "Preferências",
    "payments": "Pagamentos",
    "pricing-plans": "Planos de Preços",
    "login-singup": "Entrar/Cadastrar",
    "404": "Páginas 404",
    "faq": "FAQ",
    "client": "Cliente",
    "client_create": "Criar",
    "vehicle": "Veículo",
    "settings": "Configurações",
    "baixados": "Baixados",
    "available": "Disponíveis",
    "sold": "Vendidos",
    "company": "Empresa",
    "company_overview": "Dados da Empresa",
    "sales": "Vendas",
    "sales_list": "Lista",
    "sales_new": "Nova venda",
    "user": "Usuários",
    "rel": "Relatório",
    "rel_procuracao": "Procuração",
    "procurador": "Procurador",
    "crm": "Atendimento",
    "agenda": "Agenda de Tarefas",
    "tarefas": "Tarefas",
    "oportunidades": "Oportunidades",
    "negociacao": "Negociações",
    "propostas": "Propostas",
    "kanban": "Kanban",
    "dashboard_negociacao": "Dashboard",
    "template": "Templates",
    "bot_atendimento": "Bot de Atendimento",
    "storage": "Armazenamento",
    "painel": "Painel Atendimento",
    "contato": "Contatos",
    "businessHour": "Horário de Funcionamento",
    "demos": "Demos",
    "leadContactDemo": "Leads e Contatos",
    "leadTest": "LeadTest",
    "history": "Histórico",
    "tags": "Tags",
    "reports": "Relatórios",
    "reports_general": "Relatórios Gerais",
    "reports_templates": "Templates",
    "reports_executions": "Execuções",
    "config_company": "Configuração CRM",
    "lead_list": "Lista de Leads"
  },
  "messages": {
    "all": "Ver todas as mensagens",
    "new": "Novas mensagens de {name}",
    "mark_as_read": "Marcar como Lido"
  },
  "navbar": {
    "messageUs": "Perguntas de desenvolvimento web:",
    "repository": "Repositório GitHub"
  },
  "notifications": {
    "all": "Ver todas as notificações",
    "mark_as_read": "Marcar como lida",
    "sentMessage": "enviou uma mensagem",
    "uploadedZip": "fez upload de um novo arquivo Zip com {type}",
    "startedTopic": "iniciou um novo tópico"
  },
  "user": {
    "language": "Mudar Idioma",
    "logout": "Sair",
    "profile": "Meu Perfil",
    "settings": "Configurações",
    "billing": "Faturamento",
    "faq": "FAQ",
    "helpAndSupport": "Ajuda & Suporte",
    "projects": "Projetos",
    "account": "Conta",
    "explore": "Explorar",
    "automations_processes": "Automações / Processamentos"
  },
  "treeView": {
    "basic": "Básico",
    "icons": "Icones",
    "selectable": "Selecionável",
    "editable": "Editável",
    "advanced": "Advançado"
  },
  "chat": {
    "title": "Gráficos"
  },
  "helpAndSupport": "Ajuda & Suporte",
  "aboutVuesticAdmin": "Sobre Vuestic Admin",
  "search": {
    "placeholder": "Buscar..."
  },
  "vuestic": {
    "select": "Selecionar",
    "toggleDropdown": "Alternar",
    "close": "Fechar",
    "clear": "Limpar",
    "noOptions": "Sem opções",
    "loading": "Carregando...",
    "ok": "OK",
    "cancel": "Cancelar",
    "breadcrumbs": "Caminho de navegação",
    "resetDate": "Limpar data",
    "sortColumnBy": "Ordenar coluna por",
    "pagination": "Paginação",
    "goToSpecificPage": "Ir para página específica",
    "progressState": "Estado de progresso",
    "search": "Digite aqui",
    "movePaginationLeft": "Mover paginação para a esquerda",
    "movePaginationRight": "Mover paginação para a direita"
  }
}
